<template>
  <div>
    <common-header></common-header>
    <div class="contact">
      <div class="banner">
        <pub-animate>
          <div class="usMe" :class="{'usMeEn':lanType =='en'}" v-show="showNavPic">
            <h1 class="ft34">{{lanInfo.ContactUs}}</h1>
            <i></i>
            <!-- <p class="ft24">Contact Us</p> -->
          </div>
        </pub-animate>
      </div>
      <div class="usmeBox">
        <div class="content">
          <pub-animate enterClass="zoomIn" @showAnimate="show">
            <div class="title" v-show="showPic1" :class="{'enTitle':lanType =='en'}">
              <p style="font-weight: bold;">{{lanInfo.ContactUs}}</p>
              <i></i>
            </div>
          </pub-animate>
          <div class="itembox clearfix">
            <pub-animate enterClass="zoomIn">
              <div class="item" v-show="showPic2">
                <div>
                  <img src="../assets/images/contact/us5.png" alt>
                  <p>{{lanInfo.SchemeCounseling}}</p>
                  <p>18800023209</p>
                </div>
              </div>
            </pub-animate>
            <pub-animate enterClass="zoomIn">
              <div class="item" v-show="showPic3">
                <div>
                  <img src="../assets/images/contact/us1.png" alt>
                  <p>{{lanInfo.ContactInformation}}</p>
                  <p>010-86208510</p>
                </div>
              </div>
            </pub-animate>
            <pub-animate enterClass="zoomIn">
              <div class="item" v-show="showPic4">
                <div>
                  <img src="../assets/images/contact/us2.png" alt>
                  <p>{{lanInfo.Email}}</p>
                  <p>contact@legalXchain.com</p>
                  <p>contact@truthso.com</p>
                </div>
              </div>
            </pub-animate>
            <pub-animate enterClass="zoomIn">
              <div class="item" v-show="showPic5">
                <div>
                  <img src="../assets/images/contact/us3.png" alt>
                  <p>Telegram</p>
                  <a href="https://t.me/LegalXchain">
                    <p class="p">{{lanInfo.clickEnter}}>></p>
                  </a>
                </div>
              </div>
            </pub-animate>
            <pub-animate enterClass="zoomIn">
              <div class="item" style="margin-right:0" v-show="showPic6">
                <div>
                  <img src="../assets/images/contact/us4.png" alt>
                  <p>Twitter</p>
                  <a href="https://mobile.twitter.com/legalxchain/following">
                    <p class="p">{{lanInfo.clickEnter}}>></p>
                  </a>
                </div>
              </div>
            </pub-animate>
          </div>
        </div>
      </div>
      <div class="lyBox">
        <div class="content">
          <pub-animate enterClass="zoomIn" @showAnimate="show6">
            <div v-show="showPic6">
              <div class="title" :class="{'enTailWe':lanType=='en'}">
                <p style="font-weight: bold;">{{lanInfo.tailWe}}</p>
                <i></i>
              </div>
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <div class="lyInput">
                  <el-form-item prop="name">
                    <el-input :placeholder="lanInfo.name" maxlength="30" v-model.trim="ruleForm.name"></el-input>
                  </el-form-item>
                  <el-form-item prop="phone">
                    <el-input :placeholder="lanInfo.Telplaceholder" v-model="ruleForm.phone"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-right:0" prop="mailbox">
                    <el-input :placeholder="lanInfo.Email" v-model.trim="ruleForm.mailbox"></el-input>
                  </el-form-item>
                </div>
                <el-form-item prop="opinion">
                  <el-input
                      type="textarea"
                      :rows="6"
                      maxlength="500"
                      v-model.trim="ruleForm.opinion"
                      :placeholder="lanInfo.pleaseEnter"
                  ></el-input>
                </el-form-item>
              </el-form>
              <p class="lyME">
                <el-button
                    :disabled="ruleForm.opinion==''"
                    @click="handelConcat"
                >{{lanInfo.ContactUs}}</el-button>
              </p>
            </div>
          </pub-animate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateMobile, validateEmail } from "@/utils/validate";

export default {
  data() {
    const names= (rule, value, callback) => {
      if (value) {
        if(value.length >1 && value.length <31){
          callback();
        }else{
          callback(new Error("姓名长度限制2-30个字"));
        }
      } else {
        callback();
      }
    };
    const phone = (rule, value, callback) => {
      if (value) {
        if (!validateMobile(value)) {
          callback(new Error("格式不正确"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const emila = (rule, value, callback) => {
      if (value) {
        if (!validateEmail(value)) {
          callback(new Error("格式不正确"));
        } else {
          if(value.length >50){
            callback(new Error("邮箱地址长度最长50个字符"));
          }else{
            callback();
          }
        }
      } else {
        callback();
      }
    };
    const opiniona= (rule, value, callback) => {
      if (value) {
          if(value.length >500 || value.length < 10){
            callback(new Error("内容长度限制为10-500字"));
          }else{
            callback();
          }
      } else {
        callback();
      }
    };
    return {
      showNavPic: false,
      showPic1: false,
      showPic2: false,
      showPic3: false,
      showPic4: false,
      showPic5: false,
      showPic6: false,
      showPic7:false,
      ruleForm: {
        name: "",
        phone: "",
        mailbox: "",
        opinion: "",
        sourceChannel:5
      },
      rules: {
        name:[
          {
            required: false,
            message: "姓名不能为空",
            validator: names,
            trigger: "change"
          }
        ],
        phone: [
          {
            required: false,
            message: "格式不正确",
            validator: phone,
            trigger: "change"
          }
        ],
        mailbox: [
          {
            required: false,
            trigger: "change",
            validator: emila,
            message: "格式不正确"
          }
        ],
        opinion:[
          {
            required: false,
            trigger: "blur",
            validator: opiniona,
            message: "内容长度限制为10-500字"
          }
        ]
      }
    };
  },
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.ContactUs;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
  mounted() {
    setTimeout(() => {
      this.showNavPic = true;
    }, 1);
  },
  methods: {
    handelConcat() {
      let _this = this;
      _this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if(this.ruleForm.phone || this.ruleForm.mailbox){
          _this.$ajax
              .post("/webapi/about/aboutTruthso/addOpinion",
                  _this.ruleForm
              )
              .then(res => {
                if (res.data.code != 4002) {
                  _this.$message({
                    message: res.data.message,
                    type: "error"
                  });
                  _this.ruleForm = {
                    name: "",
                    phone: "",
                    mailbox: "",
                    opinion: ""
                  };
                }else{
                  _this.$message({
                    message: '提交成功',
                    type: "success"
                  });
                  _this.ruleForm = {
                    name: "",
                    phone: "",
                    mailbox: "",
                    opinion:""
                }
              }
              });
          }else{
            _this.$message({
              message: '手机号和邮箱必须填写一项',
              type: "error"
            });
          }
        }
      });
    },
    show() {
      setTimeout(() => {
        this.showPic1 = true;
      }, 800);
    },
    show6(val) {
      if (this.showPic5) {
        setTimeout(() => {
          this.showPic7 = true;
        }, 80);
      } else if (val == "show") {
        setTimeout(() => {
          this.showPic7 = true;
        }, 3200);
      }
    }
  },
  watch: {
    showPic1(val) {
      if (val) {
        let index = 2;
        let interval = setInterval(() => {
          this["showPic" + index++] = true;
          if (index == 7) {
            clearInterval(interval);
          }
        }, 800);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.contact {
  position: relative;
  z-index: 0;
  .content {
    width: 1200px;
    overflow: hidden;
    margin: 0 auto;
  }
  .banner {
    width: 100%;
    background: url("../../src/assets/images/contact/lxwm_bj.png") no-repeat;
    background-size: 100% 100%;
    height: 418px;
    text-align: center;
    position: relative;
    .usMe {
      width: 150px;
      height: 66px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -75px;
      margin-top: -33px;
      color: #fff;
      cursor: pointer;
      i {
        width: 50px;
        border-bottom: 2px solid #0650ca;
        display: inline-block;
        transition: all 0.7s ease-in-out 0s;
      }
      &:hover {
        i {
          width: 130px;
        }
      }
    }
    .usMeEn {
      width: 185px;
      margin-left: -92px;
      &:hover {
        i {
          width: 185px;
        }
      }
    }
  }
  .downloadText {
    border: 1px solid #0650ca;
    border-radius: 3px;
    text-decoration: none;
    display: inline-block;
    line-height: 30px;
    text-align: center;
    color: #0650ca;
    transition: all 0.7s ease-in-out 0s;
    border: none;
    outline: none;
    background: #fff;
    width: 100%;
    &:hover {
      color: #fff;
      background: #0650ca;
    }
  }
  .title {
    text-align: center;
    margin-bottom: 20px;
    p {
      font-size: 26px;
    }
    i {
      width: 40px;
      border-bottom: 2px solid #0650ca;
      display: inline-block;
      transition: all 0.7s ease-in-out 0s;
    }
    &:hover {
      i {
        width: 100px;
      }
    }
  }
  .enTitle {
    &:hover {
      i {
        width: 145px;
      }
    }
  }
  .enTailWe {
    i {
      width: 120px;
    }
    &:hover {
      i {
        width: 200px;
      }
    }
  }
  .usmeBox {
    height: 400px;
    background: #fafafa;
    padding: 40px 0;
    .itembox {
      .item {
        position: relative;
        width: 219px;
        float: left;
        text-align: center;
        border: 1px solid #ccc;
        height: 210px;
        box-sizing: border-box;
        margin-right: 26px;
        cursor: pointer;
        background: #fff;
        a {
          text-decoration: none;
          .p {
            &:hover {
              color: #0650ca;
            }
          }
        }
        & > div {
          position: absolute;
          width: 270px;
          height: 140px;
          left: 50%;
          top: 50%;
          margin-left: -135px;
          margin-top: -70px;
          font-size: 14px;
          p {
            &:nth-of-type(1) {
              color: #333;
            }
            &:nth-of-type(2) {
              color: #666;
            }
            &:nth-of-type(3) {
              color: #666;
              line-height: 12px;
            }
          }
        }
        img {
          margin-bottom: 10px;
          transition: all 0.7s ease-in-out 0s;
          &:hover {
            transform: rotate(360deg);
          }
        }
        p {
          line-height: 30px;
        }
      }
    }
  }
  .lyBox {
    .content {
      height: 404px;
    }
    .title {
      margin: 20px 0;
    }
    .lyInput {
      margin-bottom: 20px;
      .el-input {
        width: 100%;
        display: inline-block;
      }
    }
    .lyME {
      margin: 20px auto 40px auto;
      text-align: center;
      cursor: pointer;
      width: 126px;
      line-height: 35px;
      color: #0650ca;
    }
  }
  .yesdisabled {
    line-height: 35px;
    width: 100%;
    background: #8c8c8c;
    cursor: not-allowed;
    color: #fff;
    border: 0;
    border-radius: 3px;
  }
  .nodisabled {
    border: 1px solid #0650ca;
    line-height: 35px;
    width: 100%;
    border-radius: 3px;
    background: #fff;
    color: #0650ca;
    cursor: pointer;
    transition: all 0.7s ease-in-out 0s;
    &:hover {
      color: #fff;
      background: #0650ca;
    }
  }
}
</style>

<style lang="scss">
.contact {
  .lyInput {
    .el-form-item {
      width: 31%;
      margin-right: 41px;
      display: inline-block;
    }
  }
  .el-textarea {
    width: 100%;
  }
  .el-button {
    border: 1px solid #0650ca;
    transition: all 0.7s ease-in-out 0s;
    color: #0650ca;
  }
  .el-button:focus,
  .el-button:hover {
    color: #fff;
    background: #0650ca;
  }
  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #fff !important;
    cursor: not-allowed !important;
    background-image: none;
    background-color: #8c8c8c;
    border-color: #8c8c8c;
  }

  .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner:focus {
    border-color: #0650ca;
  }
  .el-form-item.is-success .el-textarea__inner,
  .el-form-item.is-success .el-input__inner {
    border-color: #ccc;
  }
  .el-textarea__inner:focus,
  .el-input__inner:focus {
    border-color: #0650ca;
  }
  .el-input.is-active .el-input__inner {
    border-color: #ccc;
  }
  .el-input__inner,
  .el-textarea__inner {
    border-color: #ccc;
  }
}
</style>

